import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy Auth0 OIDC callback handler.
 *
 * Phase 6 cutover: Auth0 is no longer the auth provider, so this route
 * doesn't have a real job anymore. Anyone hitting `/callback` (stale
 * bookmark, old browser tab mid-flow, etc.) is bounced to /login where they
 * can sign in with password or request a magic link.
 *
 * Kept (rather than deleted) so existing bookmarks and Auth0 redirect URIs
 * still land somewhere sensible during the post-cutover transition.
 */
export default function Callback() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/login', { replace: true });
  }, [navigate]);

  return null;
}
